(ns app.core
  (:require
   [reagent.dom :as rdom]
   [re-frame.core :as re-frame]
   [re-posh.core :refer [connect!] :as re-posh]
   [datascript.core :refer [create-conn conn-from-db empty-db]]
   [datascript.transit :as dt]
   [app.events :as events]
   [app.routes :as routes]
   [app.views :as views]
   [app.config :as config]
   [app.new-workspace.views :refer [new-workspace-panel]]
   [app.workspace-settings.views :refer [workspace-settings-panel]]
   [app.dashboard.views :refer [dashboard-panel dashboard-view-panel]]
   [app.login.views :refer [login-panel forgot-password-panel reset-password-panel reset-password-success-panel verify-email-panel]]
   [app.home-page.views :refer [home-page-panel]]
   [app.strive-forms.views :refer [strive-forms-container]]
   ["commandbar" :as commandbar]))

(defn dev-setup [ds]
  (when config/debug?
    (enable-console-print!)
    (println "dev mode")
    (re-frame/dispatch-sync [::events/set-ds ds]))
  ds)

(defn init-db [ts]
  (let [ds (connect! (if ts
                       (conn-from-db (dt/read-transit-str ts))
                       (create-conn)))]
    (if-not ts (re-posh/dispatch-sync [::events/initialize-ds]))
    (re-frame/dispatch-sync [::events/initialize-db])
    ds))

;; periodically saves your Datascript db
(defn persist-ds [ds]
  (js/setInterval
   #(aset js/sessionStorage "last-state" (dt/write-transit-str @ds))
   5000)
  ds)

(defn ^:dev/after-load mount-root []
  (re-frame/clear-subscription-cache!)
  (let [root-el (.getElementById js/document "app")]
    (rdom/unmount-component-at-node root-el)
    (commandbar/init "7b68aeef")
    (rdom/render [views/main-panel] root-el)))

(defn ^:export init []
  (routes/start!)
  (-> (aget js/sessionStorage "last-state")
      init-db
      dev-setup
      persist-ds)
  (mount-root))
